export enum IntegrationType {
  Xero = "Xero",
}
